/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ViewList from './icon-view-list.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ViewList {...validProps} />;
}
SvgComponent.iconName = 'viewList';

export const ViewListIcon = svgIconWrapper(SvgComponent);
